import {Stack, Typography} from '@mui/material';
import React from 'react';

import {formatText} from 'presentation/utils';

import {OdontoHeaderSectionProps} from './types';
import {QualificationList} from 'presentation/modules/guide/shared/ui/components';

export function OdontoHeaderSection({provider}: OdontoHeaderSectionProps) {
	return (
		<Stack justifyContent="space-between">
			{provider?.qualificacoes?.length > 0 ? (
				<QualificationList qualifications={provider.qualificacoes} isInverse />
			) : null}
			<Typography variant="h6" color="primary">
				{formatText(provider.nome)}
			</Typography>
		</Stack>
	);
}
